import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The InfoAgilePurchase's component.
 */
const InfoAgilePurchaseTradedProducts = () => (
  <GridContainer padding="0 0 8px" spacing={2}>
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-InfoAgilePurchaseTradedProducts.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Corresponde al año que se desea consultar.</Item>
        <Item>Corresponde a la región.</Item>
        <Item>Indica la categoría.</Item>
        <Item>Muestra la distribución de forma jerarquíca por monto transado en cada una de las categorías.</Item>
        <Item>Corresponde al buscador por rubro.</Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default InfoAgilePurchaseTradedProducts
